interface HighlightPart {
  text: string
  match: boolean
}

export function highlightParts(text: string, query: string): HighlightPart[] {
  const needle = query.trim().toLowerCase()

  if (!needle) {
    return [{ text, match: false }]
  }

  const parts: HighlightPart[] = []
  let cursor = 0

  for (
    let found = text.toLowerCase().indexOf(needle);
    found !== -1;
    found = text.toLowerCase().indexOf(needle, cursor)
  ) {
    if (found > cursor) {
      parts.push({ text: text.slice(cursor, found), match: false })
    }

    parts.push({ text: text.slice(found, found + needle.length), match: true })
    cursor = found + needle.length
  }

  if (cursor < text.length) {
    parts.push({ text: text.slice(cursor), match: false })
  }

  return parts
}
